import React from 'react'
import { IQueryBuilderComponent } from '../IQueryBuilderComponent'
import { createParameter } from '../../lib/api'

interface IState {
  value?: string
}

class FilterByIPCriteria extends IQueryBuilderComponent<{}, IState> {
  state: IState = {}

  handleChange = (value?: string) => {
    this.setState({ value })
  }

  getParameters() {
    return [createParameter('ip', this.state.value || '')]
  }

  getType() {
    return 'ip'
  }

  render() {
    return (
      <>
        <div className="four wide column">
          <h4>IP address</h4>
        </div>
        <div className="eight wide column">
          <div className="ui form">
            <div className="field">
              <input
                name="ip"
                value={this.state.value}
                onChange={e => this.handleChange(e.target.value)}
              />
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default FilterByIPCriteria
